window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};

const hotjarIdentify = (email, name) => {
    window.hj('identify', email, { email, name });
};

export {
    hotjarIdentify,
};
